import { useTypedQuery } from '../helpers/useTypedQuery';

const cleanBodyImg = (body: string) => {
  const srcReg = new RegExp(/src="([^"]*)"/, 'gi');
  let cleaned = body.replace(srcReg, (correspondance) => {
    const res = correspondance.split('%')[0] + '"';
    return res;
  });
  const srcsetReg = new RegExp(/srcset="([^"]*)"/, 'gi');
  cleaned = cleaned.replace(srcsetReg, '');
  return cleaned;
};

export const usePost = (post_id: number) => {
  const {
    isLoading: isLoadingPost,
    data: post,
    refetch: refetchPost
  } = useTypedQuery('get', `/communication/press/{post_id}/`, {
    params: {
      path: {
        post_id
      }
    },
    queryOpts: {
      select: (post) =>
        post
          ? {
              ...post,
              content: {
                ...post.content,
                body: cleanBodyImg(post.content.body || '')
              }
            }
          : post
    }
  });
  return { isLoadingPost, post, refetchPost };
};
